export const ROUTES = {
  // Entry point (unchanged)
  VISMA_ONSITE: '/vismart/:friendlyUrl/:module',

  // Shared logout handler
  LOGOUT: '/logout',

  // Visitor registration flow
  VR_LOGIN: '/visitor-registration/login',
  VR_WELCOME: '/visitor-registration/welcome',
  VR_REGISTER: '/visitor-registration/register',
  VR_VIDEO: '/visitor-registration/video',
  VR_FINAL: '/visitor-registration/final',

  // EWR flow
  EWR_OTP: '/elearning-wp-remote/otp',
  EWR_WELCOME: '/elearning-wp-remote/welcome',
  EWR_REGISTER: '/elearning-wp-remote/register',
  EWR_VIDEO: '/elearning-wp-remote/video',
  EWR_FINAL: '/elearning-wp-remote/final',
  EWR_LOGOUT: '/elearning-wp-remote/logout-successful',

  // EWOS flow
  EWOS_LOGIN: '/elearning-wp-onsite/login',
  EWOS_MVE: '/elearning-wp-onsite/mve',
  EWOS_DOB: '/elearning-wp-onsite/dob',
  EWOS_WELCOME: '/elearning-wp-onsite/welcome',
  EWOS_REGISTER: '/elearning-wp-onsite/register',
  EWOS_VIDEO: '/elearning-wp-onsite/video',
  EWOS_FINAL: '/elearning-wp-onsite/final',

  // EEL flow
  EEL_OTP: '/elearning-external/otp',
  EEL_WELCOME: '/elearning-external/welcome',
  EEL_REGISTER: '/elearning-external/register',
  EEL_VIDEO: '/elearning-external/video',
  EEL_FINAL: '/elearning-external/final',
  EEL_LOGOUT: '/elearning-external/logout-successful'
} as const;

export type RouteValues = (typeof ROUTES)[keyof typeof ROUTES];

const MODULE_START_ROUTES: Record<string, string> = {
  'elearning-wp-remote': ROUTES.EWR_OTP,
  'elearning-external': ROUTES.EEL_OTP,
  'elearning-wp-onsite': ROUTES.EWOS_LOGIN
};

export function getModuleStartRoute(module: string, isLogin = false): string {
  if (isLogin && module === 'elearning-wp-onsite') return ROUTES.EWOS_MVE;
  return (
    MODULE_START_ROUTES[module] ??
    (isLogin ? ROUTES.VR_WELCOME : ROUTES.VR_LOGIN)
  );
}

// First path segment of a workflow route, e.g. 'elearning-wp-remote';
// any module that isn't an elearning one runs the visitor-registration flow
export function getWorkflowFromModule(module: string): string {
  return module in MODULE_START_ROUTES ? module : 'visitor-registration';
}
